"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useGradient: true
};
exports.useGradient = useGradient;

var _react = require("react");

var _rxjs = require("rxjs");

var _Ticker = require("../Ticker");

var _Simple = require("./Simple");

Object.keys(_Simple).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Simple[key];
    }
  });
});

var _Velocity = require("./Velocity");

Object.keys(_Velocity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Velocity[key];
    }
  });
});

var _Circular = require("./Circular");

Object.keys(_Circular).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Circular[key];
    }
  });
});

function useGradient(pointsFn, gradientFn) {
  var ticker = (0, _Ticker.useTicker)();
  var points = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    points.current = pointsFn(ticker, points.current);
  }, [pointsFn]);

  var _ref = (0, _react.useMemo)(function () {
    var subject = new _rxjs.Subject();
    return [subject.pipe.bind(subject), function (state) {
      return subject.next(state);
    }];
  }, []),
      _ref2 = _slicedToArray(_ref, 2),
      state = _ref2[0],
      setState = _ref2[1];

  (0, _react.useEffect)(function () {
    var state;
    var sub = ticker.each(function () {
      state = gradientFn(ticker, points.current, state);
      setState(state);
    });
    return function () {
      return sub.unsubscribe();
    };
  }, [gradientFn]);
  (0, _react.useDebugValue)(state, JSON.stringify);
  return state;
}